import { Service } from '../../intervenant/models/service.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { DroitRole } from './droit-role.model';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class DroitFonctionnel {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        alias: { key: 'alias', optional: true, default: '' },
        service: { key: 'idService', converter: new (DataIdConverterFactory.build(Service, 'services'))() },
        roles: { key: 'roles', converter: new (ArrayClassConverterFactory.build(DroitRole))() }
    };

    id: number;
    code: string;
    libelle: string;
    alias: string;
    service: Service;
    roles: DroitRole[] = [];
}
